import apiClient from "../apiClient";
import { ENDPOINTS } from "../endpoints";

export const automationService = {
  listRules: async () => (await apiClient.get(ENDPOINTS.automationRules)).data,
  createRule: async (payload) => (await apiClient.post(ENDPOINTS.automationRules, payload)).data,
  updateRule: async (id, payload) => (await apiClient.patch(ENDPOINTS.automationRule(id), payload)).data,
  deleteRule: async (id) => (await apiClient.delete(ENDPOINTS.automationRule(id))).data,
};

export const webhookService = {
  list: async () => (await apiClient.get(ENDPOINTS.webhooks)).data,
  subscribe: async (payload) => (await apiClient.post(ENDPOINTS.webhooks, payload)).data,
  delete: async (id) => (await apiClient.delete(ENDPOINTS.webhook(id))).data,
  deliveries: async (id) => (await apiClient.get(ENDPOINTS.webhookDeliveries(id))).data,
};

export const integrationService = {
  list: async () => (await apiClient.get(ENDPOINTS.integrations)).data,
  setConfig: async (payload) => (await apiClient.put(ENDPOINTS.integrations, payload)).data,
};
